// extracted by mini-css-extract-plugin
module.exports = {"optCustomerTable":"styles_optCustomerTable__1BWJ4","headline":"styles_headline__1LwXQ","tablePreview":"styles_tablePreview__391O5"};